import React, { useState } from 'react';
import { FiChevronRight, FiShield } from 'react-icons/fi';
import SearchField from '../SearchField';

export default function Roles({ roles, selectedId, onSelect }) {
    const [search, setSearch] = useState('');
    const visible = roles.filter((role) => role.name.toLocaleLowerCase().includes(search.trim().toLocaleLowerCase()));

    return <section className="access-panel access-role-panel" aria-labelledby="access-roles-heading">
        <div className="access-role-intro"><h2 id="access-roles-heading">Workspace roles</h2><p>Select a role to review its permissions.</p></div>
        <div className="access-role-picker"><label htmlFor="access-role-picker">Selected role</label>
            <select id="access-role-picker" value={selectedId || ''} onChange={(event) => onSelect(roles.find((role) => String(role.id) === event.target.value)?.id)}>
                {!roles.length && <option value="">No roles available</option>}
                {roles.map((role) => <option value={role.id} key={role.id}>{role.name} · {role.permissions?.length || 0} permissions</option>)}
            </select>
        </div>
        <div className="access-role-search"><SearchField label="Search roles" value={search} onChange={setSearch} placeholder="Find a role…" /></div>
        <ul className="access-role-list" aria-label="Workspace roles">
            {visible.map((role) => <li key={role.id}>
                <button type="button" className="access-role" aria-pressed={selectedId === role.id} onClick={() => onSelect(role.id)}>
                    <span className="access-role-icon"><FiShield aria-hidden="true" /></span>
                    <span className="access-role-copy"><strong>{role.name}</strong><span>{role.permissions?.length || 0} permissions</span></span>
                    <FiChevronRight className="access-role-arrow" aria-hidden="true" />
                </button>
            </li>)}
        </ul>
        {!visible.length && <div className="access-empty access-empty-small" role="status"><p>{search ? 'No matching roles.' : 'No roles available.'}</p>{search && <button type="button" className="access-text-button" onClick={() => setSearch('')}>Clear search</button>}</div>}
        <div className="access-role-footer">{search ? `${visible.length} of ${roles.length}` : roles.length} roles</div>
    </section>;
}
